angular.module('SpidApp')

.controller('ResetPasswordController',
        ['BASE_PUBLIC_URL', '$scope', 'LoginService', 'Toaster',
function (BASE_PUBLIC_URL,   $scope,   LoginService,   Toaster) {
    
	$scope.form = {
        email: null
    }
    
    $scope.img = BASE_PUBLIC_URL + "/images/laposte_angular.png"
    
    $scope.resetPassword = function (email) {
        if (!email || email.length === 0) {
            Toaster.warning('Veuillez entrer une adresse valide')
            return
        }
        
        return LoginService.resetPassword(email).then(function () {
            Toaster.show('Mot de passe reinitialisé')
        },function (reason) {
            if(reason.status === 404){
                Toaster.danger("Cet email n'existe pas")
            } else {
                Toaster.danger("Erreur à l'envoi du mail")
            }
        })
    }
}])
